import type { ConsentCategories } from './types';

/**
 * Mappatura categorie Emerge → Google Consent Mode v2.
 */
export function buildGtmConsentSignal(
  categories: ConsentCategories,
): Record<string, 'granted' | 'denied'> {
  return {
    ad_storage: categories.marketing === true ? 'granted' : 'denied',
    ad_user_data: categories.marketing === true ? 'granted' : 'denied',
    ad_personalization: categories.marketing === true ? 'granted' : 'denied',
    analytics_storage: categories.analytics === true ? 'granted' : 'denied',
    functionality_storage: categories.functional === true ? 'granted' : 'denied',
    personalization_storage: categories.functional === true ? 'granted' : 'denied',
    security_storage: 'granted', // sempre granted (necessari)
  };
}

export function fireGtmConsentDefault(): void {
  const signal = buildGtmConsentSignal({ necessary: true });
  window.dataLayer ??= [];
  sendGtagConsent('default', signal);
}

function sendGtagConsent(command: 'default' | 'update', signal: Record<string, 'granted' | 'denied'>): void {
  if (typeof window.gtag === 'function') window.gtag('consent', command, signal);
  else if (Array.isArray(window.dataLayer)) {
    // Il formato Arguments è quello del bootstrap gtag, consumato anche dopo il widget.
    const queue = function (..._args: unknown[]) { window.dataLayer!.push(arguments); };
    queue('consent', command, signal);
  }
}

/**
 * Invia consent_update a window.gtag se presente, e push su dataLayer per GTM.
 */
export function fireGtmConsentUpdate(categories: ConsentCategories): void {
  const consentSignal = buildGtmConsentSignal(categories);

  try {
    sendGtagConsent('update', consentSignal);
    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: 'emerge_consent_update',
        consent: consentSignal,
        emerge_consent_analytics: categories.analytics === true,
        emerge_consent_marketing: categories.marketing === true,
        emerge_consent_functional: categories.functional === true,
      });
    }
  } catch {
    // best effort
  }
}
